import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/StartupPage.head';
import { StartupPage } from '@pages/StartupPage';

export const Route = createFileRoute('/startup')({
  component: StartupPage,
  head: () => head,
});
